import { Immutable } from "immer";
import React, { useEffect, useState } from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import burgerIconStyles from "../../styles/composable/burger-icon.module.scss";
import styles from "./index.module.scss";

type IProps = Immutable<{
    isMobileNav: boolean;
}> & {
    closeModal: (event: React.MouseEvent<HTMLElement>) => void;
};

const DropdownCloseButton = (props: IProps): React.ReactNode => {
    const [initCloseIconAni, setInitCloseIconAni] = useState(false);

    useEffect(() => {
        setInitCloseIconAni(true);
    }, []);

    const burgerIconClassName = concatClassNames([
        burgerIconStyles.burgerIcon,
        initCloseIconAni ? burgerIconStyles.burgerIconOpen : null,
    ]);

    return (
        <button
            onClick={(e) => {
                props.closeModal(e);
            }}
            className={styles.headerDropdownClose}
        >
            <span className={burgerIconClassName} aria-hidden="true"></span>
            {/* TODO(i18n): Wrap user-facing string in t tagged template: {t`Close`} */}
            <span className="ada-screenreader-only">Close</span>
        </button>
    );
};

export default DropdownCloseButton;
